export const API_BASE_URL = import.meta.env["VITE_API_BASE_URL"];
export const BINANCE_WS_URL = import.meta.env["VITE_BINANCE_WS_URL"];
